import { render } from "./Problem_identification.vue?vue&type=template&id=a2dc8202&scoped=true"
import script from "./Problem_identification.vue?vue&type=script&lang=js"
export * from "./Problem_identification.vue?vue&type=script&lang=js"

import "./Problem_identification.vue?vue&type=style&index=0&id=a2dc8202&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dc8202"]])

export default __exports__